import { render, staticRenderFns } from "./ProductsSearchForm.vue?vue&type=template&id=5ef1fc3c&scoped=true&"
import script from "./ProductsSearchForm.vue?vue&type=script&lang=js&"
export * from "./ProductsSearchForm.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSearchForm.vue?vue&type=style&index=0&id=5ef1fc3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef1fc3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VSheet,VTextField})
